module.exports = __webpack_public_path__ + "static/media/msl1.f07004cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl1.jpg
// module id = 27
// module chunks = 0